import { render } from "./SystemSettingData.vue?vue&type=template&id=51878198&scoped=true"
import script from "./SystemSettingData.vue?vue&type=script&lang=js"
export * from "./SystemSettingData.vue?vue&type=script&lang=js"

import "./SystemSettingData.vue?vue&type=style&index=0&id=51878198&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51878198"],['__file',"src/views/h5/common/basedata/setting/SystemSettingData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51878198"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51878198', __exports__)) {
    api.reload('51878198', __exports__)
  }
  
  module.hot.accept("./SystemSettingData.vue?vue&type=template&id=51878198&scoped=true", () => {
    api.rerender('51878198', render)
  })

}


export default __exports__